'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var ArrowRightThin = function ArrowRightThin(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 6 14' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { id: 'Dark-Breadcrumb-Arrow', d: 'M.8 0L0 .7 4.6 7 0 13.3l.8.7L6 7z' })
    )
  );
};
/*eslint-enable */

exports.default = ArrowRightThin;
//# sourceMappingURL=ArrowRightThin.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/ArrowRightThin.js